/*
  Contraband product page behaviour (2026-10-11 redesign) - styles in assets/cb-product.css,
  markup in sections/template-product.liquid. Source of truth: shopify_theme/ in the HQ repo.

  1. Moves each part of the product description to its new place: the feature list into
     "About this item", the other tabs into fold-outs, the FAQ next to the slideshow, the
     feature graphics into the slideshow. Every description already follows the same pattern
     (intro <p>, .tab_content_wrapper > .tab_item_N, .product_faq, .slideshow-container), so
     none of the 26 descriptions had to change and Google still reads the same text. A part
     that doesn't follow the pattern just stays where it was, at the bottom of the page.
  2. Photo grid: 4 large photos plus rows of smaller ones to fill the column beside the buy box,
     a full-screen viewer ("View all photos" opens it at the first photo not in the grid), and
     only the picked colour's photos, its main photo first.
  3. Slideshow controls: arrows, counter, swipe.
*/
(function () {
  var root = document.querySelector('[data-cb-pdp]');
  if (!root || root.cbReady) return;
  root.cbReady = true;

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }
  function takeChildren(from) {
    var out = [];
    while (from && from.firstChild) out.push(from.removeChild(from.firstChild));
    return out;
  }
  function label(text) {
    text = (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  function fold(title, nodes, open) {
    var d = el('details');
    if (open) d.open = true;
    d.appendChild(el('summary', null, title));
    var body = el('div', 'cb-acc__body');
    nodes.forEach(function (n) { body.appendChild(n); });
    d.appendChild(body);
    return d;
  }
  // Text a shopper would see: older descriptions also carry <style>, <script> and <meta> left
  // over from a copied slideshow tutorial, which isn't content (JS's \s already covers &nbsp;).
  function hasContent(node) {
    if (!node) return false;
    var c = node.cloneNode(true);
    Array.prototype.forEach.call(c.querySelectorAll('style, script, meta, link'), function (x) { x.parentNode.removeChild(x); });
    return c.textContent.replace(/\s/g, '') !== '' || !!c.querySelector('img, video, iframe');
  }

  var openViewer = null; // set up with the photo grid below

  // ---- 1. The description, taken apart ----
  var desc = root.querySelector('[data-cb-desc]');
  var about = root.querySelector('[data-cb-about]');
  var acc = root.querySelector('[data-cb-acc]');
  var more = root.querySelector('[data-cb-more]');
  var slidesBox = root.querySelector('[data-cb-slides]');
  var frame = root.querySelector('[data-cb-frame]');
  var textBox = root.querySelector('[data-cb-text]');

  if (desc) {
    // That leftover <style> sets body { font-family: Verdana } for the whole page; drop it.
    Array.prototype.forEach.call(desc.querySelectorAll('style, meta'), function (x) { x.parentNode.removeChild(x); });
    var tabs = desc.querySelector('.tab_content_wrapper');
    var intro = [];
    if (tabs && tabs.parentNode === desc) {
      // Paragraphs before the tabs are the short intro: they open the Description fold-out.
      while (desc.firstChild && desc.firstChild !== tabs) {
        var first = desc.removeChild(desc.firstChild);
        if (first.nodeType === 1 && hasContent(first)) intro.push(first);
      }
      var names = Array.prototype.map.call(tabs.querySelectorAll('.tab_nav'), function (t) { return t.textContent; });
      var items = tabs.querySelectorAll('.tab_item');
      var folds = [];
      Array.prototype.forEach.call(items, function (item, i) {
        var inner = item.querySelector('.product_description > div') || item.querySelector('.product_description') || item;
        var name = label(names[i] || '');
        var list = inner.querySelector('ul');
        if (i === 0 && list && about) {
          about.appendChild(list);
          about.hidden = false;
          // Phones show the first 3 features (cb-product.css); this button shows the rest.
          var count = list.querySelectorAll('li').length;
          if (count > 3) {
            var all = el('button', 'cb-about__more', 'Show all ' + count + ' features');
            all.type = 'button';
            all.addEventListener('click', function () { about.classList.add('is-open'); });
            about.appendChild(all);
          }
          if (hasContent(inner)) folds.push(fold(name || 'Features', takeChildren(inner)));
          return;
        }
        if (!hasContent(inner)) return;
        var nodes = takeChildren(inner);
        if (/^description/i.test(name) && intro.length) { nodes = intro.concat(nodes); intro = []; }
        folds.push(fold(name || 'Details', nodes));
      });
      if (intro.length) folds.unshift(fold('Description', intro));
      // In front of the fold-outs the page already has (Shipping & returns).
      folds.forEach(function (d) { acc.insertBefore(d, acc.querySelector('[data-cb-static]')); });
      desc.removeChild(tabs);
    }

    // FAQ: each question (h3) and its answer become a fold-out; the first one starts open.
    var faq = desc.querySelector('.product_faq');
    if (faq && textBox) {
      var heading = faq.querySelector('h2');
      var box = el('div', 'cb-acc cb-faq');
      var q = null, answer = [];
      function flush() { if (q) box.appendChild(fold(q, answer, !box.firstChild)); answer = []; }
      takeChildren(faq).forEach(function (n) {
        if (n === heading) return;
        if (n.nodeType === 1 && n.tagName === 'H3') { flush(); q = n.textContent.trim(); }
        else if (q && (n.nodeType === 1 || n.textContent.trim())) answer.push(n);
      });
      flush();
      if (heading) faq.appendChild(heading);
      faq.appendChild(box);
      textBox.appendChild(faq);
    }

    // Feature graphics: the old (never working) slideshow, or images left loose in the description.
    var old = desc.querySelector('.slideshow-container');
    var slides = [];
    if (old) {
      slides = Array.prototype.slice.call(old.querySelectorAll('.mySlides'));
      slides.forEach(function (s) { frame.appendChild(s); });
      old.parentNode.removeChild(old);
    } else {
      Array.prototype.forEach.call(desc.querySelectorAll('img'), function (img) {
        var s = el('div', 'mySlides');
        s.appendChild(img);
        frame.appendChild(s);
        slides.push(s);
      });
    }
    if (slides.length) setupSlides(slides); else slidesBox.hidden = true;
    // Any description image that didn't become a slide gets its src back (the template held it back).
    Array.prototype.forEach.call(desc.querySelectorAll('img[data-cb-src]'), function (im) {
      if (!im.getAttribute('src')) im.setAttribute('src', im.getAttribute('data-cb-src'));
    });

    // Whatever is left (description text that didn't fit the pattern) stays readable.
    if (!hasContent(desc)) desc.classList.add('is-empty');
    else if (!textBox.firstChild) { textBox.appendChild(desc); desc.style.paddingTop = '0'; }

    var hasText = !!textBox.firstChild;
    if (!hasText) textBox.hidden = true;
    if (!slides.length && !hasText) more.hidden = true;
    else if (!slides.length || !hasText) more.classList.add('is-solo');
    if (slides.length) {
      fitSlides();
      window.addEventListener('load', fitSlides);
      window.addEventListener('resize', fitSlides);
      textBox.addEventListener('toggle', fitSlides, true); // an FAQ answer opening
    }
  }

  // Desktop: the graphic (2000 x 4990) is cut to the height of the FAQ beside it, with "View
  // full graphic" to read it all - no empty space under the FAQ (Chris, Oct 11: "without huge
  // gaps and empty areas"). Phones get a 420 px preview from cb-product.css.
  function fitSlides() {
    if (!frame || slidesBox.hidden) return;
    var cap = 0;
    if (window.innerWidth >= 990) {
      var bar = slidesBox.querySelector('.cb-slides__bar');
      cap = textBox.hidden ? 560 : Math.max(360, textBox.offsetHeight - (bar ? bar.offsetHeight + 12 : 0));
      var im = frame.querySelector('.mySlides.is-active img');
      var tall = im && im.naturalWidth ? frame.clientWidth * im.naturalHeight / im.naturalWidth : Infinity;
      if (tall <= cap) cap = 0; // short enough to show whole
    }
    frame.style.maxHeight = cap ? cap + 'px' : '';
    frame.classList.toggle('is-capped', !!cap);
  }

  function setupSlides(slides) {
    var n = slides.length, at = 0;
    var counter = slidesBox.querySelector('[data-cb-count]');
    var nav = slidesBox.querySelector('[data-cb-nav]');
    slides.forEach(function (s) {
      s.removeAttribute('style');
      var img = s.querySelector('img');
      if (!img) return;
      // These are 2000 px wide originals; the slide shows them at 440 px, so ask the CDN for 900.
      // The template sends them without a src (data-cb-src) so nothing downloads yet - show() sets it.
      var src = img.getAttribute('data-cb-src') || img.getAttribute('src') || '';
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(src) && !/[?&]width=/.test(src)) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
      img.cbSrc = src;
      // ...and let each screen pick its file (Oct 12, Chris: smaller "if they dont impact visual
      // clarity"): 600 px for most phones and plain desktop screens, 900 for sharp desktops, 1200 for
      // 3x phones (sharper than the 900 they had). The originals in Shopify Files are untouched.
      var base = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(base)) {
        var sep = base.indexOf('?') > -1 ? '&' : '?';
        img.cbSrcset = [600, 900, 1200].map(function (w) { return base + sep + 'width=' + w + ' ' + w + 'w'; }).join(', ');
      }
      if (img.getAttribute('src')) { img.removeAttribute('src'); img.removeAttribute('srcset'); }
      img.setAttribute('loading', 'lazy');
      img.removeAttribute('style');
      if (!img.getAttribute('alt')) img.setAttribute('alt', '');
    });
    // The others wait (lazy); the one on show loads once the slideshow is within 600 px of the
    // screen - not with the page, where on phones it was 310 KB of the first load while sitting far
    // below the buy box (Oct 12). The frame is watched, not the image: a lazy image with no size yet
    // never counts as on screen, so it would never load (seen on phones, Oct 11).
    var near = !('IntersectionObserver' in window);
    function show(im) {
      if (!im || !near) return;
      im.setAttribute('loading', 'eager');
      if (!im.getAttribute('src') && im.cbSrc) {
        if (im.cbSrcset) { im.setAttribute('sizes', '(min-width: 480px) 440px, calc(100vw - 32px)'); im.setAttribute('srcset', im.cbSrcset); }
        im.setAttribute('src', im.cbSrc);
      }
      if (!im.complete) im.addEventListener('load', fitSlides, { once: true });
    }
    if (!near) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        near = true;
        show(slides[at].querySelector('img'));
      }, { rootMargin: '600px 0px' });
      io.observe(frame);
    }
    function go(i) {
      at = (i + n) % n;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === at); });
      show(slides[at].querySelector('img'));
      if (counter) counter.textContent = (at + 1) + ' / ' + n;
      fitSlides();
    }
    go(0);
    // Shown when the graphic is cut short (phones always, desktop via fitSlides): opens it full screen.
    var full = el('button', 'cb-slides__open', 'View full graphic');
    full.type = 'button';
    full.addEventListener('click', function () {
      var list = slides.map(function (s) {
        var img = s.querySelector('img');
        return { src: img ? (img.cbSrc || img.getAttribute('src') || '').replace(/width=900/, 'width=1400') : '', alt: img ? img.alt : '' };
      });
      if (openViewer) openViewer(list, at, full, true);
    });
    frame.appendChild(full);
    if (n < 2) { nav.hidden = true; return; }
    slidesBox.querySelector('[data-cb-prev]').addEventListener('click', function () { go(at - 1); });
    slidesBox.querySelector('[data-cb-next]').addEventListener('click', function () { go(at + 1); });
    var x0 = null;
    frame.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    frame.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(at + (dx < 0 ? 1 : -1));
    });
  }

  // ---- 2. Photo grid ----
  var gallery = root.querySelector('[data-cb-gallery]');
  if (gallery) {
    var order = Array.prototype.slice.call(gallery.querySelectorAll('.cb-gallery__item'));
    // The photos the grid shows right now (another colour's photos are hidden, see below).
    var tiles = function () { return Array.prototype.slice.call(gallery.querySelectorAll('.cb-gallery__item:not(.is-other)')); };
    var moreBtn = gallery.querySelector('[data-cb-gallery-more]');
    var buy = root.querySelector('.cb-buy');
    var under = root.querySelector('.cb-hero__reviews');

    // Only the picked colour's photos (Chris, Oct 12: "when you click on a variation, its not always
    // easy to tell which one we are looking at... the 4 panel grid can be confusing"). A photo's
    // colour comes from the variant that uses it, else from its file name: our photos are named by
    // colour ("5237-Yellow-S01") or by the colour digit at the end of the SKU ("CBL-5050-x0-02" with
    // SKU CBL-5050-10 = Black). Photos with no colour (size chart, shared graphics) show with every
    // colour. A photo's alt text wins over its file name ("Tie dye lifting gloves, Rainbow" - set on
    // 5347 and the 119 shorts, whose files are named Image1.jpg / ContrabandSports18484.jpg); keep
    // brand words out of those ("Pink Label" would read as the colour Pink). A product whose photos
    // aren't named that way keeps showing all of them.
    var colourOf = {}, photosOf = {};
    (function () {
      var json = document.querySelector('script[id^="product_json_"]'), p;
      try { p = JSON.parse(json.textContent); } catch (e) { return; }
      var names = (p.options || []).map(function (o) { return String(o.name || o).toLowerCase(); });
      var ci = names.indexOf('color'); if (ci < 0) ci = names.indexOf('colour'); if (ci < 0) return;
      var norm = function (s) { return String(s).toLowerCase().replace(/grey/g, 'gray'); };
      var digit = {}, words = {}, values = [];
      (p.variants || []).forEach(function (v) {
        var c = v.options ? v.options[ci] : v['option' + (ci + 1)];
        if (!c) return;
        if (values.indexOf(c) < 0) values.push(c);
        var m = /(\d)$/.exec(v.sku || '');      // a digit shared by two colours means nothing
        if (m) digit[m[1]] = (digit[m[1]] === undefined || digit[m[1]] === c) ? c : null;
        if (v.featured_image) {   // a photo two colours both use belongs to neither
          var f = v.featured_image.id;
          colourOf[f] = (colourOf[f] === undefined || colourOf[f] === c) ? c : null;
        }
      });
      values.forEach(function (c) { words[c] = norm(c).split(/[^a-z]+/).filter(Boolean); });
      // The colour with the most of its words in the text ("5257-Black-Pink" or "5257-BlackPink" ->
      // Black/Pink), or the SKU's colour digit ("x0"); a tie is no match.
      function colourIn(text) {
        var tokens = norm(text).split(/[^a-z0-9]+/), c = null, best = 0, tie = false;
        tokens.forEach(function (tk) { var m = /^x(\d)$/.exec(tk); if (m && digit[m[1]]) c = digit[m[1]]; });
        if (c) return c;
        values.forEach(function (v) {
          var s = tokens.indexOf(words[v].join('')) >= 0 ? words[v].length
            : words[v].filter(function (w) { return tokens.indexOf(w) >= 0; }).length;
          if (s > best) { best = s; c = v; tie = false; } else if (s && s === best) tie = true;
        });
        return tie ? null : c;
      }
      order.forEach(function (t) {
        var id = t.getAttribute('data-image-id');
        if (colourOf[id]) return;
        var im = t.querySelector('img'), alt = im ? im.getAttribute('alt') || '' : '';
        if (alt === p.title) alt = '';   // no alt text: the template falls back to the product title
        var file = (t.getAttribute('data-full') || '').split('?')[0].split('/').pop();
        try { file = decodeURIComponent(file); } catch (e) {}
        var c = (alt && colourIn(alt)) || colourIn(file.replace(/\.\w+$/, ''));
        if (c) colourOf[id] = c;
      });
      order.forEach(function (t) { var c = colourOf[t.getAttribute('data-image-id')]; if (c) photosOf[c] = (photosOf[c] || 0) + 1; });
    })();
    var filtering = Object.keys(photosOf).length >= 2, shownColour = null, firstShow = true;
    function showColour(c) {
      if (!filtering || !photosOf[c]) c = null;   // no photos of its own: show everything
      if (c === shownColour) return false;
      shownColour = c;
      order.forEach(function (t) {
        var tc = colourOf[t.getAttribute('data-image-id')];
        t.classList.toggle('is-other', !!(c && tc && tc !== c));
        gallery.insertBefore(t, moreBtn || null);   // back to the original order
      });
      return true;
    }

    // Fill the left column: after the 4 large photos, rows of 3 smaller ones while there is space
    // beside the buy box (Chris, Oct 11: "nice and tightly compacted without huge gaps and empty
    // areas"). Desktop only - below 990 px the photos and the buy box stack.
    function fill() {
      var all = tiles();
      all.forEach(function (t, i) { t.classList.toggle('is-extra', i >= 4); t.classList.remove('is-small', 'is-wide'); });
      // A colour with 1 or 3 photos: the first one full width, so the grid has no empty square.
      if (all.length === 1 || all.length === 3) all[0].classList.add('is-wide');
      // A full-width photo shows twice as wide as the template's sizes say: ask for a bigger file.
      order.forEach(function (t) {
        var im = t.querySelector('img');
        if (!im) return;
        if (!im.cbSizes) im.cbSizes = im.getAttribute('sizes') || '';
        var s = t.classList.contains('is-wide') ? '(min-width: 990px) 60vw, 100vw' : im.cbSizes;
        if (im.getAttribute('sizes') !== s) im.setAttribute('sizes', s);
      });
      if (window.innerWidth >= 990 && buy && all.length > 4) {
        var space = buy.getBoundingClientRect().bottom - (under || gallery).getBoundingClientRect().bottom;
        var row = (gallery.clientWidth - 16) / 3 + 8; // a row of 3 small photos plus the gap above it
        // A row goes in when at least half of it fits, so the two columns end as level as possible.
        for (var i = 4; i + 3 <= all.length && space >= row / 2; i += 3) {
          for (var k = i; k < i + 3; k++) {
            all[k].classList.remove('is-extra'); all[k].classList.add('is-small');
            var im = all[k].querySelector('img');
            if (im) im.setAttribute('loading', 'eager'); // was hidden, so lazy loading never started
          }
          space -= row;
        }
      }
      if (moreBtn) {
        moreBtn.hidden = !gallery.querySelector('.cb-gallery__item.is-extra:not(.is-other)');
        moreBtn.textContent = 'View all ' + all.length + ' photos';
      }
    }

    var box = el('div', 'cb-lightbox');
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product photos');
    var big = el('img');
    var close = el('button', 'cb-lightbox__close', '×'); close.type = 'button'; close.setAttribute('aria-label', 'Close');
    var prev = el('button', 'cb-lightbox__prev', '‹'); prev.type = 'button'; prev.setAttribute('aria-label', 'Previous photo');
    var next = el('button', 'cb-lightbox__next', '›'); next.type = 'button'; next.setAttribute('aria-label', 'Next photo');
    box.appendChild(big); box.appendChild(close); box.appendChild(prev); box.appendChild(next);
    document.body.appendChild(box);
    // The viewer shows a list of {src, alt}: the product photos, or (tall) the feature graphics.
    var list = [], shown = 0, opener = null;
    function show(i) {
      shown = (i + list.length) % list.length;
      big.src = list[shown].src;
      big.alt = list[shown].alt;
      box.scrollTop = 0;
    }
    function open(items, i, from, tall) {
      list = items; opener = from;
      box.classList.toggle('is-tall', !!tall);
      prev.hidden = next.hidden = list.length < 2;
      show(i); box.hidden = false; document.documentElement.style.overflow = 'hidden'; close.focus();
    }
    function shut() { box.hidden = true; document.documentElement.style.overflow = ''; if (opener) opener.focus(); }
    function photos() {
      return tiles().map(function (t) { var im = t.querySelector('img'); return { src: t.getAttribute('data-full'), alt: im ? im.alt : '' }; });
    }
    openViewer = open;
    gallery.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.cb-gallery__item');
      if (t) open(photos(), tiles().indexOf(t), t, false);
    });
    // "View all photos" starts at the first photo the grid isn't showing.
    if (moreBtn) moreBtn.addEventListener('click', function () {
      var all = tiles(), first = 0;
      for (var i = 0; i < all.length; i++) { if (all[i].classList.contains('is-extra')) { first = i; break; } }
      open(photos(), first, moreBtn, false);
    });
    close.addEventListener('click', shut);
    prev.addEventListener('click', function () { show(shown - 1); });
    next.addEventListener('click', function () { show(shown + 1); });
    box.addEventListener('click', function (e) { if (e.target === box) shut(); });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') shut();
      else if (e.key === 'ArrowLeft') show(shown - 1);
      else if (e.key === 'ArrowRight') show(shown + 1);
    });

    // Called by the theme's variant code with the picked variant's photo: only that colour's photos,
    // that photo first. A short fade when the colour changes, so the switch is noticed.
    window.cbPdpShowImage = function (imageId) {
      var t = gallery.querySelector('[data-image-id="' + imageId + '"]');
      var changed = showColour(colourOf[imageId]);
      var list = tiles();
      if (!changed && (!t || t === list[0])) return;
      if (t && list.length && t !== list[0]) gallery.insertBefore(t, list[0]);
      fill();
      gallery.scrollLeft = 0;
      if (changed && !firstShow) {
        gallery.classList.remove('is-fresh'); void gallery.offsetWidth; gallery.classList.add('is-fresh');
      }
      firstShow = false;
    };

    // Photos load before they're needed (Chris, Oct 12: switching colour took "a good 1-2 seconds" -
    // the next colour's photos only started downloading on the click). Pointing at, tapping or
    // tabbing to a swatch starts as many of that colour's photos as the grid shows (4 large + a
    // row of small ones on desktop); once the page has loaded and gone quiet, the same for every
    // colour in the background (phones, or data saver on: just each colour's first photo). An
    // eager image downloads even while it's hidden.
    function warm(c, n) {
      var k = 0;
      order.forEach(function (t) {
        if (k >= n || colourOf[t.getAttribute('data-image-id')] !== c) return;
        var im = t.querySelector('img');
        if (im && im.getAttribute('loading') !== 'eager') im.setAttribute('loading', 'eager');
        k++;
      });
    }
    if (filtering) {
      var onScreen = function () { return Math.max(4, tiles().filter(function (t) { return !t.classList.contains('is-extra'); }).length); };
      var intent = function (e) {
        var sw = e.target.closest && e.target.closest('.color_item');
        if (sw) warm(sw.getAttribute('data-val'), onScreen());
      };
      root.addEventListener('mouseover', intent);
      root.addEventListener('focusin', intent);
      root.addEventListener('touchstart', intent, { passive: true });
      window.addEventListener('load', function () {
        setTimeout(function () {
          var saver = navigator.connection && navigator.connection.saveData;
          var n = window.innerWidth >= 990 && !saver ? onScreen() : 1;
          Object.keys(photosOf).forEach(function (c) { warm(c, n); });
        }, 1500);
      });
    }

    // Measure again whenever the two columns can change height: fonts arriving, the window
    // resizing, a fold-out opening in the buy box ('toggle' doesn't bubble, so capture it).
    fill();
    window.addEventListener('load', fill);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fill);
    var resized = null;
    window.addEventListener('resize', function () { clearTimeout(resized); resized = setTimeout(fill, 150); });
    if (buy) buy.addEventListener('toggle', fill, true);
  }
})();